import { render } from "./TasksCriticalListView.vue?vue&type=template&id=9907a11c"
import script from "./TasksCriticalListView.vue?vue&type=script&lang=js"
export * from "./TasksCriticalListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__